import React, { ReactNode } from 'react';
import { Heading } from '../../../../components/Heading/Heading';
import Btn, { BtnModifier } from '../../../../../components/molecules/Btn';
import { Icons } from '../../../../../components/atoms/SVG';
import { CustomErrorTypeMessages, DefaultStatusMessages, StatusMessages } from '../../../partials/StatusMessages';
import { useSonTranslation } from '../../../../../translation/useSonTranslation';
import { FetchState } from '../../../../../hooks/reducers/useFetchReducer';
import { AxiosError, AxiosResponse } from 'axios';
import { SonResponseError } from '../../../types/SonResponseError';
import { ButtonRefType } from '../../../../../components/molecules/Btn/Btn';

export type AcceptDeclineFormTemplate = DefaultStatusMessages &
  CustomErrorTypeMessages & {
    headline: string | ReactNode;
    hierarchy?: number;
    fetchState: FetchState<AxiosResponse<any>, AxiosError<SonResponseError>>;
    onDecline?: () => void;
    acceptButtonRef?: ButtonRefType;
    declineButtonRef?: ButtonRefType;
  };

export function AcceptDeclineFormTemplate({
  headline,
  fetchState,
  messageSuccess,
  messageForward,
  messageSending,
  messageFail,
  customErrorTypeMessages,
  hierarchy = 3,
  onDecline,
  acceptButtonRef,
  declineButtonRef,
}: AcceptDeclineFormTemplate) {
  const shouldDisableButton = fetchState.type === 'success' || fetchState.type === 'loading';
  const { t } = useSonTranslation('AcceptDeclineForm');

  return (
    <>
      <div className="accept-decline-form">
        <Heading hierarchy={hierarchy} className="accept-decline-form__headline">
          {headline}
        </Heading>
        <div className="accept-decline-form__buttons">
          <Btn
            reference={acceptButtonRef}
            text={t('yes')}
            svgSpriteId={Icons.ACCEPT_CHECK}
            hiddenText
            type="submit"
            modifier={[BtnModifier.SINGLE_ACTION, BtnModifier.SINGLE_ACTION_YES]}
            ariaDisabled={shouldDisableButton}
          />
          <Btn
            reference={declineButtonRef}
            text={t('no')}
            svgSpriteId={Icons.DECLINE_CROSS}
            hiddenText
            type="button"
            onClick={onDecline}
            modifier={[BtnModifier.SINGLE_ACTION, BtnModifier.SINGLE_ACTION_NO]}
            ariaDisabled={shouldDisableButton}
          />
        </div>
      </div>
      <StatusMessages
        messageSuccess={messageSuccess}
        messageForward={messageForward}
        messageSending={messageSending}
        messageFail={messageFail}
        customErrorTypeMessages={customErrorTypeMessages}
        fetchState={fetchState}
      />
    </>
  );
}
